module.exports = __webpack_public_path__ + "img/Close2.08b4ed17.svg";